// AG Grid initialization module
import * as agGrid from 'ag-grid-community';
import { LicenseManager } from 'ag-grid-enterprise';

// Wait for Angular to be available before initializing ag-grid
const initializeAgGrid = () => {
  try {
    // Check if angular is available globally
    if (typeof (window as any).angular === 'undefined') {
      console.log('Angular not yet available, retrying ag-grid initialization...');
      setTimeout(initializeAgGrid, 100);
      return;
    }
    
    // Initialize ag-grid with Angular 1
    agGrid.initialiseAgGridWithAngular1((window as any).angular);
    
    // Set ag-grid enterprise license
    LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-073427}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Indexed_I/O,_Corp.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Indexed_I/O}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Indexed_I/O}_need_to_be_licensed___{Indexed_I/O}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{20_February_2026}____[v3]_[01]_MTc3MTU0NTYwMDAwMA==8a5afd9b6183cd5e9989970023a1e41e");
    
    console.log('ag-grid initialized successfully');
  } catch (error) {
    console.error('Failed to initialize ag-grid:', error);
  }
};

// Initialize ag-grid when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAgGrid);
} else {
  initializeAgGrid();
}